/**
 * 小窝 3D 猫演示开关（AVATAR-HOME-01，6796；与 6c2b、I 约定，2026-09-27）。
 * 三个条件同时成立才打开：前端数据模式是 fixture、这份快照的数据来源是 fixture、网址显式带 `?cat3d=1`。
 * live 的真实宠物带了参数也不开——CatStray 是一只通用的猫，不能冒充任何玩家的宠物（用户：“先当演示看看效果”）。
 * 不读 localStorage，不因别的状态自动打开。关着时小窝与原来逐字节一样：不加载 three、不请求 GLB。
 */
export const CAT3D_PARAM = "cat3d";

export function cat3dEnabled(input: {
  dataMode: string;
  dataOrigin: string | null | undefined;
  search: URLSearchParams | string;
}): boolean {
  if (input.dataMode !== "fixture" || input.dataOrigin !== "fixture") return false;
  const params = typeof input.search === "string" ? new URLSearchParams(input.search) : input.search;
  return params.get(CAT3D_PARAM) === "1";
}
